import gql from 'graphql-tag'

export const NOTE_SIMPLE = gql`
  fragment NoteSimple on Note {
    id

    private
    severity
    title
    description

    created_at
    updated_at
  }
`
